// Utility to create a PDF.js worker with Promise.withResolvers polyfill
// This approach fetches the worker content and bundles it with the polyfill

let cachedWorkerUrl: string | null = null;

export async function createPolyfilledWorkerUrl(): Promise<string> {
  // Return cached URL if already created
  if (cachedWorkerUrl) {
    return cachedWorkerUrl;
  }

  // The polyfill code
  const polyfillCode = `
// Polyfill for Promise.withResolvers (ES2024)
// Required for older browsers (Safari < 17.4, Chrome < 119, Firefox < 121)
if (typeof Promise.withResolvers === 'undefined') {
  Promise.withResolvers = function () {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

`;

  try {
    // Fetch the actual PDF.js worker code
    const response = await fetch('/pdf.worker.min.mjs');
    if (!response.ok) {
      throw new Error(`Failed to fetch worker: ${response.statusText}`);
    }
    const workerCode = await response.text();

    // Combine polyfill and worker code
    const combinedCode = polyfillCode + workerCode;

    // Create a Blob from the combined code
    const blob = new Blob([combinedCode], { type: 'application/javascript' });

    // Create and cache the URL
    cachedWorkerUrl = URL.createObjectURL(blob);
    return cachedWorkerUrl;
  } catch (error) {
    console.error('Failed to create polyfilled worker:', error);
    // Fallback to original worker if fetching fails
    return '/pdf.worker.min.mjs';
  }
}
